import { useForm, zodResolver } from '@mantine/form';
import { useState } from 'react';

import { TSDRevokePresentationNotificationData, TSDRevokePresentationNotificationSchema } from '@e-origin/contracts';

import { useRevokePresentationNotification } from '@hooks/tsd';

interface UseRevokePresentationNotificationFormInitializerProps {
  tsdId: string;
  onHide(): void;
}

export const useRevokePresentationNotificationFormInitializer = ({ tsdId, onHide }: UseRevokePresentationNotificationFormInitializerProps) => {
  const revokePresentationNotificationMutation = useRevokePresentationNotification();
  const [submitting, setSubmitting] = useState(false);

  const buildFormValues = (): TSDRevokePresentationNotificationData => ({
    tsdId: tsdId,
    revocationReason: '',
  });

  const form = useForm<TSDRevokePresentationNotificationData>({
    mode: 'uncontrolled',
    initialValues: buildFormValues(),
    validate: zodResolver(TSDRevokePresentationNotificationSchema),
    validateInputOnBlur: true,
  });

  const onSubmit = async (values: TSDRevokePresentationNotificationData) => {
    try {
      setSubmitting(true);

      await revokePresentationNotificationMutation.mutateAsync(values);
    } catch (err) {
      // silent fail - toast handled
    } finally {
      setSubmitting(false);
      onHide();
    }
  };

  return { form, onSubmit, buildFormValues, submitting };
};
